import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
// import DeviceContext from "../../../services/indentifyDevice";
import LoginScreen from "../../../components/VendorComponents/VendorLogin/LoginScreen/LoginScreen";
import { MyAuthContext } from "../../../Context/AuthContext";
import { vendorLogin } from "../../../services/login/loginApiService";
import { getServerKey } from "../../../services/encription/encriptionServices";
import LoginService from "../../../services/login/loginService";
import {
  addTolocalStorage,
  getTolocalStorage,
  keyClockclient,
} from "../../Constants/commenFeatures";
import { RoutesUrl } from "../../Routes/constents";
import {
  encryption,
  decryption,
  hashingFeatures,
} from "../../../services/encription/encryption";
import { vendorGetAllApps } from "../../../services/MyApps/myAppServise";

export interface VendorLoginCtrlState {
  disableForm: boolean;
  errorMsg?: string;
  // popupMessage?: string;
}

const VendorLoginCtrl: React.FC = (props) => {
  // login starts with LOGIN screen
  const [loginCtrl, setLoginCtrl] = React.useState<VendorLoginCtrlState>({
    disableForm: false,
    errorMsg: undefined,
  });

  const [loginForm, setLoginForm] = useState<any>({
    userName: "",
    password: "",
  });

  const history = useHistory();

  const myAuthContext = useContext(MyAuthContext);

  const submitLoginForm = async () => {
    await getServerKey(getServerTokenRes);
    // console.log("hash", hash);
  };

  const getServerTokenRes = async (res: any, newResp: any) => {
    var SPK = newResp.headers.get("SPK");
    if (res && res.error) {
      setLoginCtrl({
        disableForm: true,
        errorMsg: "Something went wrong, Please try again later",
      });
    } else {
      const hashPassword = await hashingFeatures(loginForm.password);
      let jsonData = JSON.stringify({
        user: {
          userName: loginForm.userName,
          password: hashPassword,
        },
        client: keyClockclient,
      });
      // Here we are encrypt the data
      let encrypedForm = await encryption(SPK, jsonData);
      vendorLogin(submitLoginFormRes, encrypedForm.reqObj, encrypedForm.header);
    }
  };

  const mySubAppsRes = (res: any) => {
    if (res && res.data) {
      addTolocalStorage("apiKey", res.data.apiKey);
      addTolocalStorage("appNm", res.data.appNm);
      history.push(RoutesUrl.VendorDashboard);
    } else {
      history.push(RoutesUrl.VendorMyApps);
    }
  };

  const callOnLoad = async () => {
    let getldId = await getTolocalStorage("ldID");
    if (getldId !== undefined && getldId) {
      vendorGetAllApps(mySubAppsRes, getldId);
    }
  };

  const submitLoginFormRes = async (res: any, newResp: any) => {
    if (!res || res.error) {
      setLoginCtrl({
        disableForm: true,
        errorMsg: res.error.errorMessage,
      });
    } else if (res && res.response) {
      let CEPRK = newResp.headers.get("CEPRK");

      // After getting response we need to decrypt the response
      let decryptedData = await decryption(CEPRK, res.response);
      // after getting decrypted Data
      LoginService.logout();
      await addTolocalStorage("loginAs", "vendor");
      await addTolocalStorage("ldID", decryptedData.data.leadID);
      await addTolocalStorage(
        "access_token",
        decryptedData.data.token.access_token
      );
      await addTolocalStorage("tncAccepted", true);
      myAuthContext.isAuthFunction(true, true);
      callOnLoad();
    } else {
      setLoginCtrl({
        disableForm: true,
        errorMsg: "Request failed",
      });
    }
  };

  const onClose = () => {
    history.push(RoutesUrl.Home);
  };

  const removeError = () => {
    setLoginCtrl({
      disableForm: false,
      errorMsg: undefined,
    });
  };

  const getScreen = () => {
    return (
      <div className="vendor_login">
        <LoginScreen
          disableForm={loginCtrl.disableForm}
          onSubmit={submitLoginForm}
          errorMsg={loginCtrl.errorMsg}
          onRemoveError={removeError}
          onClose={onClose}
          loginForm={loginForm}
          setLoginForm={setLoginForm}
        />
      </div>
    );
  };

  return <div>{getScreen()}</div>;
};

export default VendorLoginCtrl;
